import { useGateValue } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Custom hook to check if WCCS Event Status Checker is enabled.
 *
 * Returns `true` if either the local feature flag ("enable-event-status-checker")
 * or the Statsig feature gate ("enable_wccs_event_checker") is enabled.
 * This allows for enabling the feature via either mechanism.
 */
export const useEnableWccsEventChecker = (): boolean => {
  const featureFlag = useFeatureFlag("enable-event-status-checker");
  const featureGate = useGateValue("enable_wccs_event_checker");

  return featureFlag || featureGate;
};
